<template>
    <div class="global_content_course" :class="[dark ? 'dark' : '']">
        <div class="content">
            <div class="sidebar" :class="showSidebar ? 'show' : 'hide'">
                <SideBar
                    :activeModule="activeModule"
                    :nameCourse="nameCourse"
                    :data="dataModulesxLesson"
                    :currentLesson="currentLesson"
                    @updateLessonName="updateCurrentLessonName"
                    @lessonChanged="updateCurrentLesson"
                    @typeChanged="updateCurrentTypeLesson"
                />
            </div>
            <div class="viewcontent" :class="!showSidebar ? 'full' : 'less'">
                <div class="title">
                    <div class="infoLeft" style="cursor:pointer;">
                        <fa icon="bars" @click="toggleSidebar()" />
                    </div>
                    <div class="infoCenter d-none d-md-block">
                    {{ currentLesson?.title || '' }}
                    </div>
                    <div class="infoRigth">
                        <router-link to="/aluno/dashboard">
                            <fa icon="house" />
                        </router-link>
                        <span @click="toggleDarkModeLocal" v-if="dark"><fa icon="sun" /></span>
                        <span @click="toggleDarkModeLocal" v-if="!dark"><fa icon="moon" /></span>
                    </div>
                </div>
                <!-- <div class="titleMobile">
                    <fa icon="fa-graduation-cap"/>
                    <p>{{ currentCoursePortal.name }}</p>
                </div> -->
                <ViewCourse />
            </div>
        </div>
    </div>
</template>

<script>
import SideBar from './sidebar.vue';
import ViewCourse from './viewContent.vue';

import api from '@/utils/portal/modulesLesson.js';
import apiLesson from '@/utils/portal/lesson.js';
import { mapState, mapActions } from 'vuex';
import { toast } from 'vue3-toastify';


export default {
    data() {
        return {
            dataModulesxLesson: null,
            currentLessonLocal: null,
            currentLessonName: null,
            typeCurrentLesson: null,
            nameCourse: null,
            activeModule: 11,
            listLesson: [],
            dataCourse: null,
            hasLastLesson: false,
        };
    },
    components: {
        SideBar,
        ViewCourse,
    },
    computed: {
        ...mapState([
            'token',
            'showSidebar',
            'dark',
            'currentLesson',
            'currentModuleOpen',
            'idLessonPortal',
            'nameCurrentLesson',
            'currentCoursePortal',
        ]),
    },
    methods: {
        ...mapActions([
            'toggleDarkMode',
            'storeTypeLessonPortal',
            'storeIdLessonPortal',
            'storeCurrentModuleOpen',
            'storeCurrentLesson',
            'storeNameCurrentLesson',
            'storeShowSidebar',
        ]),

        getLessonsArray(data) {
            const lessonsArray = [];
            data.forEach((item) => {
                if (item.lessons) {
                    lessonsArray.push(...item.lessons);
                }
            });
            this.listLesson = lessonsArray;
            console.debug(this.listLesson);

            if (this.listLesson && this.listLesson.length > 0) {
                this.storeIdLessonPortal({ idLessonPortal: this.listLesson[0].id });
                this.storeCurrentLesson({ currentLesson: this.listLesson[0] });
                this.storeTypeLessonPortal({ typeLessonPortal: this.listLesson[0].type });
                this.storeCurrentModuleOpen({ currentModuleOpen: 0 });
                this.storeNameCurrentLesson({ nameCurrentLesson: this.listLesson[0].title });
            } else {
                console.warn('Nenhuma lição encontrada ao processar os módulos.');
            }
        },

        async getDataLessonAndModules(id) {
            try {
                const response = await api.getDataModulesAndLesson(this.token, id);
                this.dataModulesxLesson = response;
                this.getLessonsArray(response);
            } catch (error) {
                toast.error('Erro ao gerar a lista de módulos e lições');
                console.error('Erro ao gerar a lista de módulos e lições');
            }
        },


        updateCurrentLesson(lessonId, typeLesson) {
            this.storeCurrentLesson({ currentLesson: lessonId });
            this.typeCurrentLesson = typeLesson;
        },
        updateCurrentTypeLesson(typeLesson) {
            this.typeCurrentLesson = typeLesson;
        },
        updateCurrentLessonName(nameLesson) {
            this.currentLessonName = nameLesson;
        },
        updateReviewMode(review) {
            this.currentLessonName = review;
        },
        toggleSidebar() {
            this.storeShowSidebar({ showSidebar: !this.showSidebar });
        },
        toggleDarkModeLocal() {
            this.toggleDarkMode({ dark: !this.dark });
        },
    },
    async created() {
        const idCourse = this.$route.params.slug;
        await this.getDataLessonAndModules(idCourse);

        // Só busca a última lição se a action existir e o método for relevante
        if (typeof this.getLastLesson === 'function') {
            await this.getLastLesson(idCourse);
        }
    },
};
</script>

<style scoped>
.global_content_course.dark .titleMobileContent {
    background-color: gray;
    color: white;
}
.global_content_course.dark .titleMobile {
    color: white;
}
.global_content_course{
    height: 100vh;
}
.content {
    display: flex;
}
.sidebar {
    width: calc(100% - 300px);
    width: 300px;
}
@media (max-width: 768px) {
    .sidebar {
        width: 60%;
    min-width: 60%;;
    }
    .viewcontent{
        width: 100%!important;
    }
}
.dark .sidebar {
    border: 1px solid #646464;
}

.viewcontent{
    width: calc(100% - 300px);
    background-color: #f7f7f7;
}
.viewcontent .title {
    background-color: white;
    padding: 15px 20px;
    display: flex;
    gap: 15px;
    align-items: center;
    justify-content: space-between;
}
.viewcontent .title p{
    margin: 0;
    font-size: 17px;
    font-weight: 500;
}
.infoLeft {
    display: flex;
    gap: 10px;
    align-items: center;
}
.infoLeft i {
    color: #26bdbe;
}
.infoRigth {
    display: flex;
    gap: 10px;
    align-items: center;
    cursor: pointer;
}
.infoRigth a {
    text-decoration: none;
    color: #26bdbe;
}
.infoRigth i {
    font-size: 11px;
    color: #26bdbe;
}
</style>

<style>
.global_content_course.dark .hedaer {
    background-color: black;
    color: white;
}
.global_content_course.dark .v-expansion-panel {
    background-color: black;
    color: white;
    border-bottom: 1px solid #555555;
}
.global_content_course.dark .viewcontent {
    background-color: black;
}
.global_content_course.dark .title {
    background-color: black;
}
.global_content_course.dark .infoRigth a {
    color: white;
}
.global_content_course.dark .global_sidebar {
    background-color: black;
}
.global_content_course.dark .box_question_quiz.review {
    background-color: #727272;
    color: white;
}
.global_content_course.dark .number_question_quiz{ 
    border-bottom: 1px solid #000000;
}
.sidebar.hide {
    opacity: 0;
    display: none;
    transition: all 500ms linear;
}
.viewcontent.full {
    width: 100%;
}
.titleMobile p {
    margin: 0;
}
.titleMobile  {
    text-align: left;
    padding: 10px 20px;
    display: flex;
    gap: 10px;
}
.infoCenter img {
    width: 110px;
}
svg.svg-inline--fa {
    color: white;
}
.dark svg.svg-inline--fa {
    color: white;
}
.infoCenter {
    color: #8c8c8c;
    font-size: 18px;
    font-weight: 600;
}
</style>